import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { isASCII } from './string';

export function useTimeout(callback, milliseconds) {
  const thisCallback = useRef();

  useEffect(() => {
    thisCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function executeCallback() {
      thisCallback.current();
    }
    if (milliseconds != null) {
      let id = setTimeout(executeCallback, milliseconds);
      return () => {
        console.log('clearing timeout id', id);
        clearTimeout(id);
      };
    }
  }, [milliseconds]);
}

export function useInterval(callback, delay = 1000) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    let id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}

// TODO-HH - For MVP+
// For MVP+, It can be optimised to be using 1 interval timer for 1 page, and that timer returns all remaining timeout for all callers
// Currently this hook will initialise 1 interval timer for 1 remaining time. That means if there are 10 callers showing remaining time, there will be 10 interval timers.
export function useCountdown({ h, m, s, onCompleteCb }) {
  if (!h && h != 0 && !m && m != 0 && !s && s != 0) {
    throw Error(`useCountdown must be provided an input. you provided: ${(h, m, s)}`);
  }
  const intervalInMs = h * 60 * 60 * 1000 + m * 60 * 1000 + s * 1000;
  const diff = intervalInMs;
  const [started, setStart] = useState(false);
  const [remainingDuration, setRemainingDuration] = useState(moment.duration(diff, 'milliseconds'));
  const [remainingMilliseconds, setRemainingMilliseconds] = useState(remainingDuration.asMilliseconds());

  useInterval(() => {
    if (started && remainingMilliseconds !== 0) {
      setRemainingDuration(moment.duration(remainingDuration.asMilliseconds() - 1000, 'milliseconds'));
      setRemainingMilliseconds(remainingDuration.asMilliseconds());
    }
  }, 1000);

  useEffect(() => {
    if (remainingMilliseconds === 0) {
      if (onCompleteCb) {
        onCompleteCb();
      }
    }
  }, [remainingMilliseconds]);

  return {
    time: moment.utc(remainingMilliseconds),
    start: () => setStart(true),
    stop: () => setStart(false),
    updateCountDown: (newHour, newMinute, newSecond) => {
      let newDiff = newHour * 60 * 60 * 1000 + newMinute * 60 * 1000 + newSecond * 1000;
      let newRemainingDuration = moment.duration(newDiff, 'milliseconds');
      setRemainingDuration(newRemainingDuration);
      setRemainingMilliseconds(newRemainingDuration.asMilliseconds());
    },
  };
}

export function removeDuplicateArray(array, uniqueKey) {
  return _.uniqBy(array, uniqueKey);
}

export function useStringValidation(props) {
  const [validState, setValidState] = useState({
    valid: true,
    errorMessage: '',
  });

  useEffect(() => {
    if (!!props.checkCharacterLimt && props.characterLimt >= 0 && props.str.toString().length > props.characterLimt) {
      setValidState({
        valid: false,
        errorMessage: props.exceedCharLimitMsg || `${props.characterLimt} character limit exceeded`,
      });
    } else if (props.checkASCII && !isASCII(props.str.toString(), !!props.useASCIIExtended)) {
      setValidState({
        valid: false,
        errorMessage: props.exceedCharLimitMsg || APP.LANGUAGE.ShareLinkSharedText.NonASCIIError,
      });
    } else {
      setValidState({
        valid: true,
        errorMessage: '',
      });
    }
  }, [props.str]);

  return validState;
}
